module.exports = __webpack_public_path__ + "static/media/resume_2022.1a385769.pdf";